import React from "react";
import AddIcon from "../UIComponents/AddIcon";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getFlagSearchList } from "../Actions/lookupAPI";
import FlagCard from "./FlagCard";
import { toast } from "react-toastify";
import axios from "axios";
import API from "../helpers/api";
import Role from "../helpers/role";
import { confirmAlert } from "react-confirm-alert";
import $ from "jquery";

let currentuser = JSON.parse(localStorage.getItem("currentUser"));
let user = localStorage.getItem("UserRoles");
// let SearchItems={
//   Country: "",
//   PageNumber: 1,
//   PageSize: 20,
// }
class FlagSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchData: {
        Country: "",
        Mail: currentuser.email,
        PageNumber: 1,
        PageSize: 20,
      },
    };
    this.SearchFlag = this.SearchFlag.bind(this);
    this.ClearInput = this.ClearInput.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }
  componentDidMount() {
    const { dispatch, flagSearch, t } = this.props;
    if (flagSearch) {
      this.state.searchData = flagSearch;
    }
    dispatch(getFlagSearchList(this.state.searchData));
    dispatch({ type: "SubBannerTitle", data: "Flag" });
    let searchitem = this.state.searchData;
    let _this = this;
    this.keyPressHandler = function (event) {
      var keycode = event.keyCode || event.which;

      if (keycode === 13) {
        if (_this.state.searchData.Country != "") {
          _this.SearchFlag(1);
        }
        else {
          toast.success(t('Toast.Success'), {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      }
    }

    $(document).keypress(this.keyPressHandler);
  }

  componentWillUnmount() {

    $(document).off("keypress", this.keyPressHandler);
  }


  SearchFlag(pgno) {
    const { dispatch } = this.props;
    this.state.searchData.PageNumber = pgno;
    dispatch({ type: "flagSearch", data: this.state.searchData });
    dispatch(getFlagSearchList(this.state.searchData));
  }

  SearchFlag1(pgno) {
    const { dispatch, t } = this.props;
    if (this.state.searchData.Country !== '') {

      this.state.searchData.PageNumber = pgno;
      dispatch({ type: "flagSearch", data: this.state.searchData });
      dispatch(getFlagSearchList(this.state.searchData));
    }
    else {
      toast.success(t('Toast.Success'), {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    this.state.searchData[nodeName] = e.target.value;
    this.setState({});
  }

  ClearInput() {
    // let param={...SearchItems}
    this.state.searchData.PortName = "";
    this.state.searchData.Country = "";
    this.state.searchData.Mail = currentuser.email;
    this.setState({});
    this.props.dispatch({ type: "flagSearch", data: "" });
    this.props.dispatch(getFlagSearchList(this.state.searchData));
  }

  NewitemNav = () => {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/LookupFlagAdd");
    this.props.dispatch({ type: "FlagApplicableServices", data: "" });
  };
  eyeclick(item) {
    const { dispatch, history } = this.props;
    dispatch({ type: "flagDetails", data: item });
    history.push(`/Home/LookupFlagEdit/${item.flagId}`);
    dispatch({ type: "FlagApplicableServices", data: "" });
  }

  deleteFlag(item) {
    const { t } = this.props;
    confirmAlert({
      message: `${t("confirmAlertMessage.DeleteMsg")}`,
      buttons: [
        {
          label: `${t("confirmAlertMessage.Yes")}`,
          onClick: () => {
            const { dispatch, FlagSearchList } = this.props;
            let flaginfo = {
              flagId: item.flagId,
              countryname: item.countryName,
              attachmentName: item.attachmentName,
              attachmentGuid: item.attachmentGuid,
              isDeleted: true,
              modifiedBy: currentuser.name,
            };
            let url = `${API.postFlag}`;
            axios
              .put(url, flaginfo)
              .then((response) => {
                let searchData = {
                  Country: "",
                  Mail: currentuser.email,
                  PageNumber: this.state.searchData.PageNumber - 1,
                  PageSize: 20,
                };
                if (
                  FlagSearchList.pagination.hasNext === false &&
                  FlagSearchList.data.length === 1
                ) {
                  dispatch({ type: "flagSearch", data: searchData });
                  dispatch(getFlagSearchList(searchData));
                } else {
                  dispatch({ type: "flagSearch", data: this.state.searchData });
                  dispatch(getFlagSearchList(this.state.searchData));
                }
                dispatch({
                  type: "putFlagDetailSuccess",
                  data: response.data,
                });
                this.ClearInput()
                toast.success(t('confirmAlertMessage.DeletedSuccessMessage'), {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              })
              .catch((error) => {
                dispatch({
                  type: "putFlagDetailFailure",
                  error: "ERROR",
                });
              });
          },
        },
        {
          label: `${t("confirmAlertMessage.No")}`,
          onClick: () => { },
        },
      ],
    });
  }
  render() {
    const { showSidePane, FlagSearchList, t } = this.props;
    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-lg-12">
                  <div className="panel-box">
                    <div
                      className="card MM-card-header mb-0"
                      style={{ backgroundColor: "white" }}
                    >
                      <div
                        className="card-body flex"
                        style={{
                          padding: "0rem",
                          backgroundColor: "#1a3464",
                          color: "white",
                        }}
                      >
                        <h5
                          className="card-title ml-2 mt-2 f2"
                          style={{ color: "092a51" }}
                        >
                          {t("TopPaneContent.Flag")}
                        </h5>
                        {user === Role.mmpladmin ?
                          <div className="m-1 flex" onClick={this.NewitemNav}>
                            <span className="mt-1">
                              {t("ShipManagementContent.Add")}
                            </span>
                            <AddIcon />
                          </div> : null}
                      </div>
                    </div>
                    <div className="search-filter-box">
                      <div className="row">
                        <div className={"col-lg-6"}>
                          <label className="form-label">
                            {t("TopPaneContent.Flag")}
                          </label>
                          <br></br>
                          <input
                            className="form-control"
                            type="text"
                            name="Country"
                            value={this.state.searchData.Country}
                            placeholder={t("TopPaneContent.Flag")}
                            onChange={(e) => this.handleInputChange(e)}
                          ></input>
                        </div>
                        <div className={"col-lg-6"}>
                          <br></br>
                          <div
                            className="form-group search-btn-col pt-3"
                            style={{ textAlign: "end" }}
                          >
                            <button
                              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                              type="submit"
                              onClick={() => this.SearchFlag1(1)}
                            >
                              {" "}
                              {t("content.Search")}{" "}
                            </button>
                            <button
                              className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                              type="button"
                              onClick={() => this.ClearInput()}
                            >
                              {" "}
                              {t("content.Clear")}{" "}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {FlagSearchList ? (
                <FlagCard
                  currentPage={(FlagSearchList.pagination.currentPage - 1) * FlagSearchList.pagination.pageSize}
                  arraylist={FlagSearchList.data}
                  totalRecords={
                    FlagSearchList.pagination.totalcount
                      ? FlagSearchList.pagination.totalcount
                      : 0
                  }
                  pageSize={FlagSearchList.pagination.pageSize}
                  setUpdatedState={(value) => this.SearchFlag(value)}
                  eyeclick={(item) => this.eyeclick(item)}
                  deleteFlag={(item) => this.deleteFlag(item)}
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
  openEditScreen() {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/EditClient");
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan,
    FlagSearchList: state.lookupReducer.FlagSearchList,
    flagSearch: state.lookupReducer.flagSearch,
  };
}
export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(FlagSearch))
);
